import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from '@map/services/user.service';
import { NotificationService } from '@shared/services/notification.service';
import { catchError, filter, map, of, switchMap, take, tap } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

export const RoleGuard: CanActivateFn = (route) => {
    const userService = inject(UserService);
    const notificationService = inject(NotificationService);
    const requiredRoles = route.data['roles'] as string[];

    return toObservable(userService.user).pipe(
        switchMap((user) => (user ? of(user) : userService.getSelf('+Department+Role'))),
        filter((user) => !!user),
        map((user) => userService.hasRole(user!, requiredRoles)),
        tap((hasAccess) => {
            if (!hasAccess) {
                notificationService.displayErrorMessage('You do not have access to view this page');
            }
        }),
        catchError((error) => {
            notificationService.displayErrorMessage('An error occurred while checking user roles');
            return of(false);
        }),
        take(1)
    );
};
